module.exports = __webpack_public_path__ + "img/ertiga-xl7-boostergreen-glx-blanco-estelar.0c7142c1.png";